import addSearchAgent from './add-search-agent'
import addTrend from './add-trend'
import card from './card'
import contextMenu from './context-menu'
import copy from './copy'
import createTrendradarButton from './create-trendradar-button'
import deprecatedTrends from './deprecated-trends'
import description from './description'
import deletion from './deletion'
import edit from './edit'
import emptyTrends from './empty-trends'
import form from './form'
import header from './header'
import leave from './leave'
import list from './list'
import microtrendContext from './microtrend-context'
import notifications from './notifications'
import participants from './participants'
import relatedTrends from './related-trends'

export default {
    addSearchAgent,
    addTrend,
    card,
    contextMenu,
    copy,
    createTrendradarButton,
    deletion,
    deprecatedTrends,
    description,
    emptyTrends,
    edit,
    form,
    header,
    leave,
    list,
    microtrendContext,
    notifications,
    participants,
    relatedTrends,
    disabled: 'Become a participant to gain full access'
}
